import { render } from "./LayoutInput.vue?vue&type=template&id=b08a519a&scoped=true"
import script from "./LayoutInput.vue?vue&type=script&lang=js"
export * from "./LayoutInput.vue?vue&type=script&lang=js"

import "./LayoutInput.vue?vue&type=style&index=0&id=b08a519a&lang=css"
import "./LayoutInput.vue?vue&type=style&index=1&id=b08a519a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08a519a"]])

export default __exports__